import { List } from '@ahmdigital/ui';
import styled from 'styled-components';

import ellipseImage from './images/ellipse.svg';

// eslint-disable-next-line import/prefer-default-export
export const StyledList = styled(List)<{
  isVertical?: boolean;
}>`
  align-items: center;
  counter-reset: list-counter;
  display: ${({ isVertical }) => (isVertical ? 'inline-block' : 'flex')};
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  list-style: none;
  margin-bottom: 1rem;
  text-align: left;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: row;
    gap: 2rem;
    margin-bottom: 3rem;
  }

  li {
    align-items: baseline;
    gap: ${({ isVertical }) => (isVertical ? '0.5rem' : '0')};
    counter-increment: list-counter;
    display: flex;
    flex-direction: row;
    width: ${({ isVertical }) => (isVertical ? 'auto' : '15rem')};

    :not(:last-child) {
      ${({ isVertical }) => isVertical && 'margin-bottom: 1.5rem'};
    }

    @media (min-width: ${({ theme }) => theme.media.sm}) {
      width: auto;
    }

    ::before {
      background: url('${ellipseImage.src}') no-repeat center center;
      border-radius: 50%;
      color: ${({ theme }) => theme.colors.white};
      content: counter(list-counter);
      display: flex;
      flex-shrink: 0;
      font-family: ${({ theme }) => theme.fontFamilies.secondary};
      font-weight: bold;
      height: 1.5rem;
      justify-content: center;
      margin-right: 0.5rem;
      width: 1.5rem;
    }
  }
`;
